import * as React from "react";
function UserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6 12.6a4.806 4.806 0 01-4.8-4.8C6.8 5.154 8.954 3 11.6 3s4.8 2.154 4.8 4.8-2.154 4.8-4.8 4.8zm0-8.8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM4.4 21a.4.4 0 01-.4-.4c0-4.19 3.41-7.6 7.6-7.6 4.19 0 7.6 3.41 7.6 7.6a.4.4 0 01-.4.4H4.4zm13.989-.8c-.209-3.548-3.212-6.4-6.789-6.4-3.577 0-6.58 2.852-6.788 6.4h13.577z"
  }));
}
const ForwardRef = React.forwardRef(UserIcon);
export default ForwardRef;